<template>
    <v-row>
        <v-btn @click="send" class="ma-5">
            Send weRepair
        </v-btn>
    </v-row>
</template>
<script>
export default {
    data: () => ({
    }),
    methods: {
        send: function () {
            this.$emit('sendWeRepair', this.dataToSend);
        }
    }
}
</script>